import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import AiAssistantInput from "@/components/html/extensions/components/AiAssistantInput.vue";

export default Node.create({
  name: 'aiAssistant',

  group: 'block',

  selectable: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      isDraggable: {
        default: true,
        renderHTML: (attributes) => {
          return {};
        }
      },
    }
  },

  parseHTML() {
    return [{
      tag: 'ai-assistant',
    }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['ai-assistant', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(AiAssistantInput);
  },

  // @ts-ignore
  addCommands() {
    return {
      setAssistant: (options: any) => ({ tr, dispatch, commands }: any) => {
        const { selection } = tr
        const node = this.type.create(options)

        const hasSelection = selection.to !== selection.from
        if (!dispatch) {
          return
        }

        if (hasSelection) {
          try {
            let position = selection.to + 1
            if (selection.$to?.depth > 1) {
              position = selection.to + 2
            }
            tr.insert(position, node)
          } catch (err) {
            // We need this because there might be cases when insertion fails
            tr.insert(selection.to + 1, node)
          }
        } else {
          tr.replaceRangeWith(selection.from, selection.to, node)
        }

        return true
      },
    }
  }
});
